import * as React from 'react';
import { WithStyles, createStyles } from '@material-ui/core';
import Grid from 'ha/ui/next/Grid';
import { Control, SliderProps, VirtualizeSliderProps } from './types';

interface WithControlsProps {
  leftControl?: Control;
  rightControl?: Control;
}

interface State {
  index: number;
}

export const styles = createStyles({
  control: {
    width: 'auto',
  },
  container: {
    overflow: 'hidden',
  },
});

export function withControls<P extends SliderProps | VirtualizeSliderProps>(
  Component: React.ComponentClass<P> | React.StatelessComponent<P>,
) {
  class WithControls extends React.Component<
    P & WithControlsProps & WithStyles<typeof styles>,
    State
  > {
    state: State = {
      index: 0,
    };

    previousSlide = () => {
      const { index } = this.state;

      this.setState({
        index: index - 1,
      });
    };

    nextSlide = () => {
      const { index } = this.state;

      this.setState({
        index: index + 1,
      });
    };

    handleChangeIndex = (index: number) => {
      this.setState({
        index,
      });
    };

    render() {
      const { index } = this.state;

      const { leftControl, rightControl, classes } = this.props;

      return (
        <Grid container>
          {leftControl && (
            <Grid
              item
              container
              alignItems="center"
              className={classes.control}
              data-test-locator="Slider LeftControl"
            >
              {leftControl({ previousSlide: this.previousSlide })}
            </Grid>
          )}
          <Grid item xs className={classes.container}>
            <Component
              index={index}
              handleChangeIndex={this.handleChangeIndex}
              {...this.props}
            />
          </Grid>
          {rightControl && (
            <Grid
              item
              container
              alignItems="center"
              className={classes.control}
              data-test-locator="Slider RightControl"
            >
              {rightControl({ nextSlide: this.nextSlide })}
            </Grid>
          )}
        </Grid>
      );
    }
  }

  return WithControls;
}
